import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import Paper from '@mui/material/Paper';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import Typography from '@mui/material/Typography';
import { Link, Route, Routes, MemoryRouter, useLocation, StaticRouter } from 'react-router';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/Box": Box, "@mui/material/ListItemButton": ListItemButton, "@mui/material/Paper": Paper, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/material/Divider": Divider, "@mui/icons-material/Inbox": InboxIcon, "@mui/icons-material/Drafts": DraftsIcon, "@mui/material/Typography": Typography, "react-router": { Link, Route, Routes, MemoryRouter, useLocation, StaticRouter } } } });
export default ClientProvider;
